module.exports = ".flags img {\n  vertical-align: middle;\n  margin-right: 8px; }\n\n.flags .mat-menu-item {\n  height: 36px;\n  line-height: 36px; }\n"